// VisualizadorPDF.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const documentos = {
  "alta-sistec": { file: "/pdf/ALTA_SISTEC.pdf", numpages: 1 },
  "aviso-privacidad-cajeros": { file: "/pdf/AVISO_DE_PRIVACIDAD_CAJEROS.pdf", numpages: 3 },
  "aviso-privacidad-general": { file: "/pdf/AVISO_DE_PRIVACIDAD_GENERAL.pdf", numpages: 3 },
  "somos-seguros": { file: "/pdf/Somos_seguros.pdf", numpages: 1 },
  "poliza-garantia": { file: "/pdf/POLIZA_DE GARANTIA_CAJERO_QUICKPAY.pdf", numpages: 3 },
};

const PdfViewer = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const { archivo } = useParams();

  useEffect(() => {
    console.log(archivo);
  }, [archivo]);

  const currentDoc = documentos[archivo];

  if (!currentDoc) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-red-500 text-xl font-semibold">Documento no encontrado</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-4 w-full max-w-4xl flex flex-col items-center">
        <p className="text-lg font-medium mb-4">
          Página {pageNumber} de {currentDoc.numpages}
        </p>

        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
            disabled={pageNumber <= 1}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            ⬅ Anterior
          </button>
          <button
            onClick={() => setPageNumber((p) => Math.min(p + 1, currentDoc.numpages))}
            disabled={pageNumber >= currentDoc.numpages}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Siguiente ➡
          </button>
        </div>

        <div className="border border-gray-300 shadow-lg rounded overflow-hidden">
          <Document file={currentDoc.file}>
            <Page pageNumber={pageNumber} width={Math.min(window.innerWidth * 0.9, 800)} />
          </Document>
        </div>
      </div>
    </div>
  );
};

export default PdfViewer;
